import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/images/rightBar/exclamationmark-triangle.svg'


const _hoisted_1 = { class: "row ptop-04 pbottom-04" }
const _hoisted_2 = {
  key: 0,
  class: "list"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 0,
  src: _imports_0,
  class: "w-12 h-12 mleft-02"
}

import addMonitored from './addMonitored.vue';
import rBarMoreMenu from "./rBarMoreMenu.vue";
import {ref, computed, watch } from 'vue';
import { useCurrentEntryStore } from '@/stores/currentEntry';
import { useUiStore } from '@/stores/ui';
import patientapi from "@/api/patientapi";
import { useI18n } from "vue-i18n";
import SharedService from "@/services/SharedService";
import { useAppUserStore } from '@/stores/appUser';
import {FolderPatientApi, GetSummaryByPatientSummaryTypeEnum, PatientSummaryResponse, PersonLightResponse} from "@/apiGenerate/medserver";
import {PersonWithRoleStatus} from "@/models/share.model";
import EsSelectHealthProDelegateModal from "@/components/modals/patient/esSelectHealthProDelegateModal.vue";
import { medServerApiConfig } from '@/config/medserver-api.config';
import { getSingleElement } from '@/utils/array-utils';
import { useRoute } from 'vue-router';
import appuserapi from "@/api/appuserapi";


export default /*@__PURE__*/_defineComponent({
  __name: 'rBarMonitored',
  props: {
    reloadPatientData: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const appUserStore = useAppUserStore();

const currentEntryStore = useCurrentEntryStore()
const uiStore = useUiStore()
const { t } = useI18n();
const route = useRoute();

//Drag 'N Drop
const isDraggingOverMonitored = ref(false)

const folderPatientApi = new FolderPatientApi(medServerApiConfig);

const isEditable = computed(() => {
  return currentEntryStore.isEditable && !currentEntryStore.currentEntry.archivedByUser;
});

const patientMonitoredResponse = computed(() => {
  return currentEntryStore.patientMonitoredResponse;
});

const reloadMonitoredData = computed(() => {
  return currentEntryStore.reloadMonitoredData;
})

const showOphtalmoDashboard = computed(() => {
  if (!appUserStore.currentHealthGroupMembership) {return false}
  return appUserStore.currentHealthGroupMembership?.instituteWithRole?.ophthalmoDashboardActive;
});

function onDragOverMonitored() {
  if (currentEntryStore.dndType !== 'exprMonitored') {
    isDraggingOverMonitored.value = true
  }    
}

function onDragLeaveMonitored() {
  isDraggingOverMonitored.value = false
}

async function onDropOverMonitored() {
  isDraggingOverMonitored.value = false;
  const dndType = currentEntryStore.dndType;
  const dndId = currentEntryStore.dndId;
  currentEntryStore.clearDnd();
  if (dndType !== 'exprMonitored') {
    await patientapi.setConceptGroupForExpression(dndId, 'Monitored', currentEntryStore.currentEntryId, undefined);
    await loadMonitoredByPatient();
  }
}

function openAddMonitored() {
  uiStore.setModalUiId("addMonitored")
}


async function dashbSelect(item) {

  const expressions = await folderPatientApi.getExpressionsByConceptGroupAndPatient({
    patientId : currentEntryStore.currentPatientId,
    conceptGroupId: item.conceptGroupId
  });
  currentEntryStore.allExpressions = expressions;
  
  const refSheetSuggestions = await appuserapi.getRefSheetsForExpr(item.expressionId)
  currentEntryStore.setCurrSuggestionsForDashboard(refSheetSuggestions)

  uiStore.setDashBoardItem(item)
}

async function openOphthalmoDashboard() {
  const checkPatientEntry = await patientapi.checkPatientEntry(currentEntryStore.currentPatientId);
  if (checkPatientEntry.newEntryNeeded) {
    createNewEntry();
  } else {
    uiStore.setDashBoardType('Ophtalmo');
  }
}

const isHealthPro = computed(() => {
  if (!appUserStore.currentAppUserData || !appUserStore.currentAppUserData.healthGroupMemberships) {return null}
  return PersonWithRoleStatus.HealthPro === appUserStore.currentAppUserData.healthGroupMemberships[0].pwr.personRoleType;
});

const openSelectHealthProDelegate = ref<boolean>(false);
const creatorId = ref<string>(undefined);
const currentPersonId = computed(() => {
  if (!appUserStore.currentAppUserData || !appUserStore.currentAppUserData.healthGroupMemberships) {return null}
  return appUserStore.currentAppUserData.healthGroupMemberships[0].pwr.personWithRoleId
});

const createNewEntry = () => {
  if (isHealthPro.value || !appUserStore.healthProDelegate || appUserStore.healthProDelegate.length === 1) {
    confirmCreateNewEntry();
  } else {
    creatorId.value = currentEntryStore.currentPatient.personWithRoleId;
    openSelectHealthProDelegate.value = true;
  }
}

const closeSelectHelathProDelegateModal = (selectedPersonLight: PersonLightResponse) => {
  if (selectedPersonLight) {
    creatorId.value = selectedPersonLight.id !== currentPersonId.value ? selectedPersonLight.id : null;
    confirmCreateNewEntry();
  } else {
    openSelectHealthProDelegate.value = false;
  }
}

async function confirmCreateNewEntry() {
  const newEntry = await currentEntryStore.createNewEntry(
      currentEntryStore.currentPatient.personWithRoleId,
      appUserStore.getCurrentInstituteWithRole().instituteWithRoleId,
      creatorId.value
  );
  openSelectHealthProDelegate.value = false;
  currentEntryStore.csList.unshift(newEntry);
  uiStore.setDashBoardType('Ophtalmo');
}

const loadMonitoredByPatient = () => {
  folderPatientApi.getSummaryByPatient(({patientId: getSingleElement(route.params.patientId), summaryType: GetSummaryByPatientSummaryTypeEnum.Monitored })).then((result: PatientSummaryResponse[]) => {
    currentEntryStore.setPatientMonitoredResponse(result);
  });
};

watch(
  () => props.reloadPatientData,
  async () => {
    if (props.reloadPatientData) {
      await loadMonitoredByPatient();
    }
  }
);

watch(
  () => reloadMonitoredData.value,
  async () => {
    if (reloadMonitoredData.value) {
      await loadMonitoredByPatient();
      currentEntryStore.setReloadMonitoredData(false);
    }
  }
);

return (_ctx: any,_cache: any) => {
  const _component_text_item = _resolveComponent("text-item")!
  const _component_es_button_icon = _resolveComponent("es-button-icon")!
  const _component_itemModal = _resolveComponent("itemModal")!
  const _component_listGroup2 = _resolveComponent("listGroup2")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["es-right-bar", [isDraggingOverMonitored.value ? 'bigshadow' : '']]),
    onDragover: _withModifiers(onDragOverMonitored, ["prevent"]),
    onDragleave: onDragLeaveMonitored,
    onDrop: _withModifiers(onDropOverMonitored, ["prevent"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_text_item, {
        txt: _unref(t)('patient.rightBar.subtitle.monitoring'),
        class: "left0 mtop-01 title",
        styles: "font-l"
      }, null, 8, ["txt"]),
      (_unref(currentEntryStore).dndType !== 'exprMonitored' && isEditable.value)
        ? (_openBlock(), _createBlock(_component_es_button_icon, {
            key: 0,
            class: "mleft-04 square-29 justify-center",
            icon: "plus",
            folder: "shareIcons",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (openAddMonitored())),
            styles: "icon-grey-style square-14"
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_itemModal, {
        center: true,
        uiId: "addMonitored"
      }, {
        modal: _withCtx(() => [
          _createVNode(addMonitored, {
            class: "item-modal",
            monitoredAdded: loadMonitoredByPatient
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(EsSelectHealthProDelegateModal, {
      "is-open": openSelectHealthProDelegate.value,
      "health-pro-delegate": _unref(appUserStore).healthProDelegate,
      onModalClose: _cache[1] || (_cache[1] = ($event: any) => (closeSelectHelathProDelegateModal($event)))
    }, null, 8, ["is-open", "health-pro-delegate"]),
    (showOphtalmoDashboard.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_listGroup2, {
            class: "row mleft-10 gap-02",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (openOphthalmoDashboard()))
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: _unref(SharedService).getIcon('exclamationmark-triangle', false, 'rightBar'),
                class: "w-12 h-12"
              }, null, 8, _hoisted_3),
              _createVNode(_component_text_item, {
                txt: _unref(t)('patient.ophtalmo.title'),
                class: "pad-s max-w-260"
              }, null, 8, ["txt"])
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(patientMonitoredResponse.value, (expr, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: "list"
      }, [
        _createVNode(_component_listGroup2, {
          class: "row mleft-10 w-full full-row",
          onClick: ($event: any) => (dashbSelect(expr))
        }, {
          default: _withCtx(() => [
            (expr.hasExclamation)
              ? (_openBlock(), _createElementBlock("img", _hoisted_4))
              : _createCommentVNode("", true),
            _createVNode(_component_text_item, {
              txt: expr.text,
              class: "pad-s"
            }, null, 8, ["txt"]),
            (isEditable.value)
              ? (_openBlock(), _createBlock(rBarMoreMenu, {
                  key: 1,
                  expr: expr,
                  class: "mleft-auto",
                  refresh: loadMonitoredByPatient,
                  onSetDeletable: ($event: any) => (expr.deletable = false)
                }, null, 8, ["expr", "onSetDeletable"]))
              : _createCommentVNode("", true),
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "mleft-04" }, null, -1))
          ]),
          _: 2
        }, 1032, ["onClick"])
      ]))
    }), 128))
  ], 34))
}
}

})